import { UNDEFINED_BUCKET } from '../schema/column-records';
import { DATASET_TABLE } from '../schema/table-records';
import { getLinkProvider } from '../metadata/links/links';
import { getFieldInfoForColumn, isFieldExpressionBased } from '../utils/column-utils';
import { COLUMN_ROLES } from 'reporting-data/constants/relationalReports';
const LINK_PREFIX = 'link_';
export const getLinkAlias = alias => `${LINK_PREFIX}${alias}`;
const linkColumn = (reportMeta, column, dataset) => {
  const isDimension = column.role === COLUMN_ROLES.DIMENSION;
  if (!isDimension) {
    return dataset;
  }
  if (isFieldExpressionBased(column.field)) {
    return dataset;
  }
  const {
    tables,
    properties
  } = reportMeta;
  const {
    table: tableName,
    name: propertyName
  } = getFieldInfoForColumn(column, reportMeta);

  // When a dataset field references a property, getFieldInfoForColumn
  // will set the field table to the relevant table name. Derived fields will have a table value of __DATASET__
  // We are not putting link for dataset derived fields
  if (tableName === DATASET_TABLE) {
    return dataset;
  }
  if (!tableName) {
    return dataset;
  }
  const snowflakeTable = tables.get(tableName);
  const snowflakeProperty = properties.getIn([tableName, propertyName]);
  const provider = getLinkProvider(snowflakeTable, snowflakeProperty);
  if (!provider) {
    return dataset;
  }
  const {
    alias
  } = column;
  return dataset.update('data', data => data.map(row => {
    const value = row.get(alias);
    if (value === UNDEFINED_BUCKET) {
      return row.set(getLinkAlias(alias), undefined);
    }
    const link = provider(value);
    return row.set(getLinkAlias(alias), link);
  }));
};
export const link = (reportDefinition, reportMeta, dataset) => {
  const {
    columns
  } = reportDefinition;
  return columns.reduce((nextDataset, column) => linkColumn(reportMeta, column, nextDataset), dataset);
};